import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import "../../Api/apiUrls.js";
import { API_URL, getUserById, updateUser } from "../../Api/apiUrls";

function ViewProfileVenue() {
  const [userData, setUserData] = useState("");
  const [fullName, setFullName] = useState("");
  const [bio, setBio] = useState("");
  const [mobileNo, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [bankname, setBankName] = useState("");
  const [account, setAccount] = useState("");
  const [code, setCode] = useState("");
  const [pancard, setPanCard] = useState("");
  const [country, setCountry] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [twitter, setTwitter] = useState("");
  const [aadharcard, setAadharcard] = useState("");
  const [gstno, setGstno] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [file, setIconFile] = useState();
  function reloadPage() {
    window.location.reload();
  }

  useEffect(() => {
    const hasReloaded = localStorage.getItem('hasReloaded');
    if (!hasReloaded) {
      // alert("hiiiiiiiiiii")
      localStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    }
  }, []);
  const userId = localStorage.getItem("user_id");
  useEffect(() => {
    // Fetch user data from the API
    fetch(`${getUserById}${userId}`)
      .then((response) => response.json())
      .then((data) => {
        const user = data.data.user;
        console.log(user.name);
        setFullName(user.name);
        setIconFile(user.profile_image);
        setBio(user.bio);
        setMobile(user.mobileNumber);
        setAddress(user.address);
        setEmail(user.email);
        setCountry(user.country);
        setFacebook(user.facebook);
        setInstagram(user.instagram);
        setTwitter(user.twitter);
        setBankName(user.bank_name);
        setAccount(user.bank_account_number);
        setCode(user.bank_ifsc_code);
        setPanCard(user.pan_card_number);
        setAadharcard(user.aadhar_card_number);
        setGstno(user.gst_number);
        setBusinessName(user.business_name);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  }, []);

  const [editable, setEditable] = useState(false);
  const [editedData, setEditedData] = useState({ ...userData });
  const [isReadOnly, setReadOnly] = useState(true);

  const handleEditClick = () => {
    setReadOnly(false);
    setEditable(true);
  };

  const handleSaveClick = async () => {
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("name", fullName);
      formData.append("profile_image", file);
      formData.append("bio", bio);
      formData.append("mobileNumber", mobileNo);
      formData.append("email", email);
      formData.append("address", address);
      formData.append("country", country);
      formData.append("facebook", facebook);
      formData.append("instagram", instagram);
      formData.append("twitter", twitter);
      formData.append("bank_name", bankname);
      formData.append("bank_account_number", account);
      formData.append("bank_ifsc_code", code);
      formData.append("pan_card_number", pancard);
      formData.append("aadhar_card_number", aadharcard);
      formData.append("gst_number", gstno);
      formData.append("business_name", businessName);

      const response = await fetch(`${updateUser}`, {
        method: "PUT",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to save data: ${response.statusText}`);
      }

      console.log("Data saved successfully");
      // reloadPage();

      setEditable(false);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    setIconFile(file);
    console.log(file);

    const formData = new FormData();
    formData.append("profile_image", file);
    const reader = new FileReader();
    reader.onload = function (e) {
      const imgElement = document.getElementById("selectedImg");
      imgElement.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setEditedData((prevData) => ({ ...prevData, [id]: value }));
  };
  return (
    <div>
      <Header></Header>
      <main id="main" class="main">
        <div class="pagetitle">
          <h1> Profile</h1>
          {/* <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item active"> Profile</li>
            </ol>
          </nav> */}
        </div>
        <section class="section">
          <div class="card p-3">
            <div class="parent col-md-12 row mt-2">
              <div className="col-md-12" style={{ textAlign: "right" }}>
                <div className="child">
                  <button
                    id="btnNewUser"
                    type="button"
                    className="btn-round"
                    onClick={handleEditClick}
                  >
                    <i className="bi bi-pencil"></i> Edit Profile
                  </button>
                </div>
              </div>
            </div>
            <form style={{ padding: "0px 30px 30px 30px" }}>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Full Name<font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputFullName"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={fullName}
                  readOnly={isReadOnly}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputDocument">
                  Cover Image
                </label>
                <br />
                <input
                  type="file"
                  id="selectedImg"
                  name="document"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                />
                <img
                  id="selectedImg"
                  src={`${API_URL}/${file}`}
                  // alt={category.name || 'No Name'}
                  style={{ width: "60px", height: "60px" }}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Bio<font color="red"></font>
                </label>
                <textarea
                  class="form-control"
                  id="inputBio"
                  type="text"
                  placeholder=""
                  style={{ height: "100px", pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={bio}
                  readOnly={isReadOnly}
                  onChange={(e) => setBio(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Mobile No.<font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputNo"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={mobileNo}
                  readOnly={isReadOnly}
                  onChange={(e) => setMobile(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Email <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputEmail"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={email}
                  readOnly={isReadOnly}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {!email.includes("@") && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Please enter a valid email address.
                  </p>
                )}
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Address <font color="red">*</font>
                </label>
                <input
                  class="form-control"
                  id="inputAddress"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={address}
                  readOnly={isReadOnly}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Country <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={country}
                  readOnly={isReadOnly}
                  onChange={(e) => setCountry(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Bank Name <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={bankname}
                  readOnly={isReadOnly}
                  onChange={(e) => setBankName(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Account No. <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={account}
                  readOnly={isReadOnly}
                  onChange={(e) => setAccount(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  IFSC Code <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={code}
                  readOnly={isReadOnly}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  PAN Card No. <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={pancard}
                  readOnly={isReadOnly}
                  onChange={(e) => setPanCard(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Aadhar Card No.
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={aadharcard}
                  readOnly={isReadOnly}
                  onChange={(e) => setAadharcard(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  GST No.
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={gstno}
                  readOnly={isReadOnly}
                  onChange={(e) => setGstno(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Business Name
                </label>
                <input
                  class="form-control"
                  id="inputCountry"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={businessName}
                  readOnly={isReadOnly}
                  onChange={(e) => setBusinessName(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Facebook <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputFacebook"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={facebook}
                  readOnly={isReadOnly}
                  onChange={(e) => setFacebook(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Instagram <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputInstagram"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={instagram}
                  readOnly={isReadOnly}
                  onChange={(e) => setInstagram(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label class="small mb-1" for="inputFullName">
                  Twitter <font color="red"></font>
                </label>
                <input
                  class="form-control"
                  id="inputTwitter"
                  type="text"
                  placeholder=""
                  style={{ pointerEvents: isReadOnly ? "none" : "auto" }}
                  value={twitter}
                  readOnly={isReadOnly}
                  onChange={(e) => setTwitter(e.target.value)}
                />
              </div>

              <div className="form-group">
                {editable && (
                  <button
                    id="btnNewUser"
                    type="button"
                    class=" btn-round"
                    onClick={handleSaveClick}
                  >
                    Save Changes
                  </button>
                )}
              </div>
            </form>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            ></div>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default ViewProfileVenue;
